import React, { useCallback, useEffect, useState } from 'react'
import {
  CBadge,
  CButton,
  CCard,
  CCardBody,
  CCol,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CFormCheck,
  CRow,
  CSmartTable,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import {
  cilCalendarCheck,
  cilDescription,
  cilOptions,
  cilSpreadsheet,
  cilTrash,
  cilUserPlus,
} from '@coreui/icons'

import moment from 'moment'
import Bootbox from 'bootbox-react'
import { useNavigate } from 'react-router-dom'
import ToastComponent from 'src/components/common/TaostComponent.js'
import FixtureService from 'src/service/FixtureService'
import CommonService from 'src/service/CommonService'
import Pusher from 'pusher-js'
import Loader from 'src/components/Loader'
import FixtureSquadTable from './FixtureSquadTable.js'

const STATUS_BADGES = {
  0: { color: 'warning', label: 'Not Started' },
  1: { color: 'info', label: 'In-Progress' },
  2: { color: 'success', label: 'Completed' },
  3: { color: 'danger', label: 'Failed' },
  4: { color: 'secondary', label: 'In-Queue' },
}

const ManageFixture = (props) => {
  const [loading, setLoading] = useState(true)
  const [loader, setLoader] = useState(true)
  const [loaderText, setLoaderText] = useState(true)

  const [activePage, setActivePage] = useState(1)
  const [columnFilter, setColumnFilter] = useState([])
  const [columnSorter, setColumnSorter] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [users, setUsers] = useState({})
  const [squadFixtureIds, setSquadFixtureIds] = useState([])
  const [inProgressFixture, setInProgressFixture] = useState([])
  const navigate = useNavigate()
  const [gameType, setGameType] = useState()
  useEffect(() => {
    CommonService.getGameType().then((res) => {
      if (res.status === 200) {
        setGameType(res.data)
      }
    })
  }, [])

  // gameType 1 fixtures only carry a single team, so the away-team column is dropped for them.
  const isSingleTeam = gameType === 1
  // gameType 1 and 4 score one team at a time instead of picking a side from the fixture.
  const isSingleTeamScoring = gameType === 1 || gameType === 4

  // Delete Fixture code started here
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([])

  const toggleAllCheckboxes = () => {
    const allIds = squadFixtureIds.map((user) => user.id)
    setSelectedCheckboxes((prevSelected) => (prevSelected.length === allIds.length ? [] : allIds))
  }

  const columns = [
    {
      key: 'delete_fixture',
      label: (
        <CFormCheck
          id="select_all_fixtures"
          aria-label="Select all fixtures without a squad"
          checked={
            selectedCheckboxes.length === squadFixtureIds.length && squadFixtureIds.length > 0
          }
          onChange={toggleAllCheckboxes}
        />
      ),
      filter: false,
      sorter: false,
    },
    {
      label: 'FID',
      key: 'id',
      _style: { width: '10%' },
    },
    {
      key: 'round',
    },
    {
      label: isSingleTeam ? 'Team Name' : 'Home Team',
      key: 'team_name',
    },
    ...(isSingleTeam ? [] : [{ label: 'Away Team', key: 'team2_name' }]),
    { label: 'Match Type', key: 'match_type', filter: false, sorter: false },
    { label: 'Start Date', filter: false, key: 'start_date' },
    { label: 'Start Time', filter: false, key: 'start_time' },
    { label: 'Status', filter: false, key: 'status' },
    {
      key: 'show_details',
      label: 'Actions',
      _style: { width: '1%' },
      filter: false,
      sorter: false,
    },
  ]

  const fetchUsers = useCallback(async () => {
    setLoader(false)
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })
    columnSorter &&
      columnSorter.column !== undefined &&
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

    try {
      const result = await FixtureService.getFixture(offset, itemsPerPage, activePage, params)
      const squadResult = await FixtureService.getSquadFixture()
      const inProgressFixtureResult = await FixtureService.getInProgressFixture()
      setUsers(result.data)
      setSquadFixtureIds(squadResult.data ?? [])
      setInProgressFixture(inProgressFixtureResult.data)
      if (inProgressFixtureResult.data && inProgressFixtureResult.data != null) {
        setLoader(true)
        setLoaderText(inProgressFixtureResult?.message)
      }
    } catch (error) {
      console.error('Error fetching users:', error)
    } finally {
      setLoading(false)
    }
  }, [activePage, itemsPerPage, columnFilter, columnSorter])

  useEffect(() => {
    fetchUsers()
  }, [fetchUsers])

  const toggleCheckbox = (id) => {
    setSelectedCheckboxes((prevSelected) => {
      if (prevSelected.includes(id)) {
        return prevSelected.filter((selectedId) => selectedId !== id)
      } else {
        return [...prevSelected, id]
      }
    })
  }

  // Delete All confirm box
  const [showDeleteAllConfirm, showShowDeleteAllConfirm] = useState(false)
  const showDeleteAllCofirmBox = () => {
    showShowDeleteAllConfirm(true)
  }
  const handleDeleteAllConfirm = () => {
    handleDeleteAllFixture()
    return showShowDeleteAllConfirm(false)
  }
  const handleDeleteAllCancel = () => {
    return showShowDeleteAllConfirm(false)
  }
  const handleDeleteAllFixture = () => {
    const data = {
      fixturesIds: selectedCheckboxes, // Include the array of IDs here
    }
    FixtureService.deleteAllFixture(data).then((res) => {
      if (res.status === 200) {
        ToastComponent(res.message, 'success')
        setLoading(false)
        setSelectedCheckboxes([])
        fetchUsers()
      }
    })
  }
  useEffect(() => {
    const pusher = new Pusher('2604209a1a0fdaa07dfc', {
      cluster: 'ap4',
    })
    const channel = pusher.subscribe('test-channel')
    channel.bind('test-event', (data) => {
      ToastComponent(data.message, 'red_error')
      fetchUsers()
    })

    const fixtureCompletionChannel = pusher.subscribe('fixture-completion-channel')
    fixtureCompletionChannel.bind('fixture-completion-event', (data) => {
      ToastComponent(data.message, 'success')
      fetchUsers()
    })
    return () => {
      // Unbind events and unsubscribe from channels
      channel.unbind_all()
      channel.unsubscribe()
      fixtureCompletionChannel.unbind_all()
      fixtureCompletionChannel.unsubscribe()
    }
  }, [fetchUsers])

  const redirectPage = (id, teamId) => {
    window.location.href = `/scorecard/${id}/${teamId}`
  }

  // show squad players
  const [teamId, setTeamId] = useState(0)
  const [teamName, setTeamName] = useState(0)
  const [fixtureId, setFixtureId] = useState(0)
  const [showSquadModal, setShowSquadModal] = useState(false)
  const showSquadPlayer = (fixtureId, teamId, teamName) => {
    setTeamId(teamId)
    setFixtureId(fixtureId)
    setShowSquadModal(true)
    setTeamName(teamName)
  }
  // Picking or dropping a player changes which fixtures still count as squad-less, so the
  // listing (and its delete checkboxes) has to be re-read when the modal reports a change.
  const closeSquadModal = (squadChanged) => {
    setShowSquadModal(false)
    if (squadChanged) {
      fetchUsers()
    }
  }

  const selectedCount = selectedCheckboxes.length

  return loader ? (
    <Loader loaderText={loaderText} />
  ) : (
    <>
      <CRow className="g-3 mb-3">
        <CCol sm={6} lg={4}>
          <CCard className="h-100">
            <CCardBody className="d-flex justify-content-between align-items-center">
              <div>
                <div className="text-medium-emphasis small">Total Fixtures</div>
                <div className="fs-4 fw-semibold">{users?.total ?? 0}</div>
              </div>
              <div
                className="d-flex align-items-center justify-content-center rounded-circle bg-primary-subtle text-primary"
                style={{ width: 42, height: 42 }}
              >
                <CIcon icon={cilCalendarCheck} size="lg" />
              </div>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol sm={6} lg={4}>
          <CCard className="h-100">
            <CCardBody className="d-flex justify-content-between align-items-center">
              <div>
                <div className="text-medium-emphasis small">Awaiting Squad</div>
                <div className="fs-4 fw-semibold">{squadFixtureIds?.length ?? 0}</div>
              </div>
              <div
                className="d-flex align-items-center justify-content-center rounded-circle bg-warning-subtle text-warning"
                style={{ width: 42, height: 42 }}
              >
                <CIcon icon={cilUserPlus} size="lg" />
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <CCard>
        <CCardBody>
          {selectedCount > 0 && (
            <div
              className="d-flex flex-wrap align-items-center gap-2 mb-3 px-3 py-2 bg-primary-subtle"
              style={{ borderRadius: '0.75rem' }}
            >
              <span className="small fw-semibold text-primary">
                {selectedCount} {selectedCount === 1 ? 'fixture' : 'fixtures'} selected
              </span>
              <div className="d-flex flex-wrap align-items-center gap-2 ms-auto">
                <CButton color="danger" size="sm" onClick={showDeleteAllCofirmBox}>
                  <CIcon icon={cilTrash} className="me-1" />
                  Delete Selected
                </CButton>
                <CButton
                  color="secondary"
                  variant="ghost"
                  size="sm"
                  onClick={() => setSelectedCheckboxes([])}
                >
                  Clear
                </CButton>
              </div>
            </div>
          )}

          <div className="ge-datatable ge-datatable--static">
            <CSmartTable
              columns={columns}
              noItemsLabel="No fixtures found"
              columnFilter={{
                external: true,
              }}
              columnSorter={{
                external: true,
              }}
              scopedColumns={{
                delete_fixture: (item) => {
                  // Only fixtures that have no squad yet can be deleted.
                  const fixtureIdExists = squadFixtureIds.some((fixture) => fixture.id === item.id)
                  return (
                    <td>
                      {fixtureIdExists && (
                        <CFormCheck
                          id={`delete_fixture_${item.id}`}
                          aria-label={`Select fixture ${item.id}`}
                          value={item.id}
                          checked={selectedCheckboxes.includes(item.id)}
                          onChange={() => toggleCheckbox(item.id)}
                        />
                      )}
                    </td>
                  )
                },
                id: (item) => <td className="fw-semibold">{item.id}</td>,
                round: (item) => <td>{item.round ?? '-'}</td>,
                team_name: (item) => (
                  <td>
                    <span
                      className="fw-semibold text-primary"
                      role="button"
                      title="View squad"
                      onClick={() => showSquadPlayer(item.id, item.team, item.team_name)}
                    >
                      {item.team_name ?? '-'}
                    </span>
                  </td>
                ),
                team2_name: (item) => (
                  <td>
                    <span
                      className="fw-semibold text-primary"
                      role="button"
                      title="View squad"
                      onClick={() => showSquadPlayer(item.id, item.team2, item.team2_name)}
                    >
                      {item.team2_name ?? '-'}
                    </span>
                  </td>
                ),
                match_type: (item) => <td>{item.match_type ?? '-'}</td>,
                status: (item) => {
                  const badge = STATUS_BADGES[item.status]
                  return (
                    <td>
                      {badge && (
                        <CBadge color={badge.color} shape="rounded-pill" className="px-2 py-1">
                          {badge.label}
                        </CBadge>
                      )}
                    </td>
                  )
                },
                grade: (item) => <td>{item.grade ?? ''}</td>,
                start_date: (item) => <td>{moment(item.start_date).format('D.MM.YYYY')}</td>,
                start_time: (item) => (
                  <td>{moment(item.start_time, ['HH:mm']).format('h:mm A')}</td>
                ),
                show_details: (item) => (
                  <td className="py-2">
                    <CDropdown alignment="end" placement="bottom-end" portal>
                      <CDropdownToggle color="transparent" caret={false} className="p-0">
                        <CIcon icon={cilOptions} role="button" />
                      </CDropdownToggle>
                      <CDropdownMenu className="ge-row-actions-menu">
                        {isSingleTeamScoring ? (
                          <>
                            <CDropdownItem
                              role="button"
                              onClick={() =>
                                navigate(`/manage-scores/team-players/${item.id}/${item.team}`)
                              }
                            >
                              <CIcon icon={cilUserPlus} className="me-2" />
                              Create Squad
                            </CDropdownItem>
                            <CDropdownItem
                              role="button"
                              onClick={() => redirectPage(item.id, item.team)}
                            >
                              <CIcon icon={cilSpreadsheet} className="me-2" />
                              Manage Scores
                            </CDropdownItem>
                          </>
                        ) : (
                          <>
                            <CDropdownHeader>Create Squad</CDropdownHeader>
                            <CDropdownItem
                              href={`/manage-scores/team-players/${item.id}/${item.team}`}
                            >
                              <CIcon icon={cilUserPlus} className="me-2" />
                              {item?.team_name}
                            </CDropdownItem>
                            <CDropdownItem
                              href={`/manage-scores/team-players/${item.id}/${item.team2}`}
                            >
                              <CIcon icon={cilUserPlus} className="me-2" />
                              {item?.team2_name}
                            </CDropdownItem>
                            <CDropdownDivider />
                            <CDropdownHeader>Manage Scores</CDropdownHeader>
                            <CDropdownItem href={`/team-scorecard/${item.id}/${item.team}`}>
                              <CIcon icon={cilSpreadsheet} className="me-2" />
                              {item?.team_name}
                            </CDropdownItem>
                            <CDropdownItem href={`/team-scorecard/${item.id}/${item.team2}`}>
                              <CIcon icon={cilSpreadsheet} className="me-2" />
                              {item?.team2_name}
                            </CDropdownItem>
                            <CDropdownItem href={`/full-scorecard/${item.id}`}>
                              <CIcon icon={cilDescription} className="me-2" />
                              Full Scorecard
                            </CDropdownItem>
                          </>
                        )}
                      </CDropdownMenu>
                    </CDropdown>
                  </td>
                ),
              }}
              items={users?.data}
              itemsPerPage={itemsPerPage}
              itemsPerPageSelect
              loading={loading}
              pagination={{
                external: true,
              }}
              paginationProps={{
                activePage: activePage,
                pages: Math.ceil(users?.total / itemsPerPage) || 1,
              }}
              tableProps={{
                hover: true,
                responsive: true,
                className: 'align-middle mb-0',
              }}
              onActivePageChange={(activePage) => setActivePage(activePage)}
              onColumnFilterChange={(filter) => {
                setActivePage(1)
                setColumnFilter(filter)
              }}
              onItemsPerPageChange={(itemsPerPage) => {
                setActivePage(1)
                setItemsPerPage(itemsPerPage)
              }}
              onSorterChange={(sorter) => setColumnSorter(sorter)}
            />
          </div>
        </CCardBody>
      </CCard>

      <FixtureSquadTable
        teamId={teamId}
        fixtureId={fixtureId}
        gameType={gameType}
        visible={showSquadModal}
        teamName={teamName}
        onClose={closeSquadModal}
      />
      <Bootbox
        show={showDeleteAllConfirm}
        type={'confirm'}
        message={`Are you sure you want to delete ${selectedCount} selected ${
          selectedCount === 1 ? 'fixture' : 'fixtures'
        }?`}
        onSuccess={handleDeleteAllConfirm}
        onCancel={handleDeleteAllCancel}
        onClose={handleDeleteAllCancel}
      />
    </>
  )
}

export default ManageFixture
